import React , {useEffect, useState} from "react"
import { navigate} from "gatsby"
import CompanyCorp from "../../images/business/company-incor.svg"
import BusinessTitleCard from "./BusinessCardTitle"
import TitleText from "./TitleText"
import ProceedButton from "./ProceedButton"
import Info from "./Info"
import { useQuery } from "../../hooks/useQuery"

const CompanyRegistration = () => {
    const [companyIncorfees, setCompanyIncorfees] = useState("55,000")
  const queryParams = useQuery("token")
  const gotoNext = () => {
    if (queryParams) {
      localStorage.setItem("incorp_token", queryParams)
      navigate("/business-support/mobile-company-reg/start", {
        state: {
          service: "New Business Incorporation",
          path: "/business-support/mobile-company-reg/start",
        },
      })
    } else {
      navigate("/business-support/verify", {
        state: {
          service: "Company Incorporation",
          path: "/business-support/mobile-company-reg/start",
        },
      })
    }
  }
  
 useEffect(() => {
   const storedData = localStorage.getItem("supportFees")

   if (storedData) {
     // Convert the JSON string back to an object
     const parsedData = JSON.parse(storedData)
    setCompanyIncorfees(parsedData)
   } else {
     console.log("No data found in localStorage.")
   }
 }, [])
  return (
    <div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <TitleText />
            <BusinessTitleCard
              icon={CompanyCorp}
              title="Company incorporation"
              subtitle="Officially register your company or incorporation, get CAC and a TIN"
            />

            <div className="business-suport-card p-lg-4 p-3 my-5">
              <div className="intro">
                <div className="ml-lg-4">
                  <ul className="list-styled ml-lg-5 pl-lg-5">
                    <li>Incorporate your business.</li>
                    <li>
                      Submit 2-4 names for the business in order of preference
                    </li>
                    <li>
                      A minimum of 1 director and shareholder is required, also
                      having a Company secretary is optional.
                    </li>
                    <li>
                      Share capital (1 million shares advisable and can be set
                      as default as registration fees increase per share
                      capital) & percentage of allocated shares
                    </li>
                    <li>
                      This service cost{" "}
                      <span>₦{companyIncorfees.companyIncorporation}.00</span> if
                      you already have a Sparkle Personal account.
                    </li>
                    <li>
                      Timeline: 10-25 working days after name approval and
                      receipt of complete required documents and information.
                    </li>
                  </ul>
                </div>

                <ProceedButton text="Proceed" handleClick={gotoNext} />
                <Info />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompanyRegistration
